import { PROFILE_SLICE } from "./slice";

export const LOAD_PROFILE_ACTION = `${PROFILE_SLICE}/loadProfile` as const;
export const UPDATE_STRIPE_CUSTOMER_ACTION = `${PROFILE_SLICE}/updateStripeCustomer` as const;